// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1264":"177d0bf6917b317388ae","1325":"715a7f40cdd53f460ef4","6464":"2fa2e5f1fa93842c62b1","8532":"88b90ac86f3060a3144e"}[chunkId] + ".css";
};